"use client";

import React, { useMemo } from "react";
import { Stack } from "@mui/material";
import { SVariantDto } from "@/__generated__/sdk";
import { useProductPageContext } from "../Providers/useProductPageContext";
import { getSellerOffersForVariants } from "../sellerOffers";
import VariantSellerOffers from "./VariantSellerOffers";

/** Seller rows for the shown variant, including the cheapest one before the shopper picks. */
export default function ProductSellerList() {
  const context = useProductPageContext();
  const matchingVariants = context?.matchingVariants ?? [];

  const variants = useMemo(() => matchingVariants as SVariantDto[], [matchingVariants]);
  const offerCount = useMemo(() => getSellerOffersForVariants(variants).length, [variants]);

  if (!context?.anyVariantAvailableToSell || offerCount < 2) {
    return null;
  }

  return (
    <Stack sx={{ gridColumn: "1 / -1", minWidth: 0, display: { xs: "none", md: "flex" } }}>
      <VariantSellerOffers variants={variants} productId={context.productId} />
    </Stack>
  );
}
